import css from 'styled-jsx/css';

const styles = css.global`#cdc-protecao {
    padding-bottom: 8px;
    overflow: hidden;
}

#cdc-protecao .ctn-home-24 {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

#cdc-protecao .protecao-contain {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
}

#cdc-protecao .protecao-contain .protecao-titulos {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

#cdc-protecao .protecao-titulos .protecao-titulo {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
}

#cdc-protecao .protecao-titulos .protecao-texto {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#cdc-protecao .protecao-conteudos {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
}

#cdc-protecao .protecao-conteudos .img-protecao {
    width: 240px;
}

#cdc-protecao .carrossel-protecao .slide {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    width: 203px;
    margin-right: 16px;
    flex: 0 0 203px;
}

#cdc-protecao .carrossel-protecao .carrossel-protecao-texto {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#cdc-protecao .carrossel-protecao .home-pagination {
    margin-top: 32px;
}

#cdc-protecao .carrossel-protecao .home-pagination .embla__prev, 
#cdc-protecao .carrossel-protecao .home-pagination .embla__next {
    width: 24px;
    height: 24px;
    background-size: 24px 24px;
}

#cdc-protecao .protecao-disclaimer {
    color: #767676;
    font-family: "SantanderMicroText";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
}

.emp-garantia-carro-img-separacao {
    width: 100%;
    height: 240px;
    object-fit: cover;
    object-position: top;
    margin-bottom: -3px;
  }
  
@media (min-width: 992px) {
    #cdc-protecao .ctn-home-24 {
        gap: 56px;
    }
    
    #cdc-protecao .protecao-contain {
        gap: 64px;
    }
    
    #cdc-protecao .protecao-contain .protecao-titulos {
        gap: 16px;
    }
    
    #cdc-protecao .protecao-titulos .protecao-titulo {
        font-size: 56px;
        line-height: 120%;
    }
    
    #cdc-protecao .protecao-titulos .protecao-texto {
        font-size: 24px;
        line-height: 36px;
    }
    
    #cdc-protecao .protecao-conteudos {
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 44px;
        max-width: 1091px;
    }
    
    #cdc-protecao .protecao-conteudos .img-protecao {
        max-width: 419px;
        width: 32%;
    }

    #cdc-protecao .cards-protecao {
        display: flex;
        flex-wrap: wrap;
        gap: 48px;
        width: 100%;
        max-width: 581px;
    }

    #cdc-protecao .card-protecao {
        width: 273px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    #cdc-protecao .card-protecao.card-menor {
        width: 256px;
    }

    #cdc-protecao .card-protecao .card-protecao-texto {
        color: #444;
        font-family: "SantanderText";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
    }

    .emp-garantia-carro-img-separacao {
        height: 320px;
    }
}`;

export default styles;